import { render, staticRenderFns } from "./NewsletterSignupsStats.vue?vue&type=template&id=5f28b615&"
import script from "./NewsletterSignupsStats.vue?vue&type=script&lang=js&"
export * from "./NewsletterSignupsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f28b615')) {
      api.createRecord('5f28b615', component.options)
    } else {
      api.reload('5f28b615', component.options)
    }
    module.hot.accept("./NewsletterSignupsStats.vue?vue&type=template&id=5f28b615&", function () {
      api.rerender('5f28b615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/NewsletterSignupsStats.vue"
export default component.exports